import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
`;
